import bo from "../assets/img/newB.jpg";
import { LoginForm } from "../components/forms/LoginForm";
export default function Login() {
  return (
    <>
      <div
        className="min-h-screen bg-cover bg-center bg-gradient-to-br from-blue-500 via-blue-400 to-blue-300 flex items-center justify-center"
        style={{
          backgroundImage: `url(${bo})`,
          backgroundRepeat: "no-repeat",
          width: "100%",
          height: "100vh",
          backgroundPosition: "left center",
          backgroundSize: "contain",
        }}
      >
        <div className="bg-white p-8 shadow-md w-full max-w-md ml-auto mr-[20rem] border-gray-200 rounded-lg ">
          <LoginForm />
        </div>
      </div>
    </>
  );
}
